/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type VideoEngagementContainer_user$ref: FragmentReference;
declare export opaque type VideoEngagementContainer_user$fragmentType: VideoEngagementContainer_user$ref;
export type VideoEngagementContainer_user = {|
  +id: string,
  +truexId: string,
  +videoAdEligible: ?boolean,
  +$refType: VideoEngagementContainer_user$ref,
|};
export type VideoEngagementContainer_user$data = VideoEngagementContainer_user;
export type VideoEngagementContainer_user$key = {
  +$data?: VideoEngagementContainer_user$data,
  +$fragmentRefs: VideoEngagementContainer_user$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "VideoEngagementContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "truexId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "videoAdEligible",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '3f56f6ecac2b6e2baa99565f36d87ce0';
module.exports = node;
